module.exports = __webpack_public_path__ + "images/emoji/bowtie.73de09ce6675cadd5975.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bowtie.png
// module id = 6cAM
// module chunks = 24